export const LICENCE_LIST = "Property/LICENCE";
export const LICENCE_ERROR = "Property/LICENCE_ERROR";
export const LOADING = "Property/LOADING";
export const APICALL = "Property/LICENCE_API_CALL";
